import {
    SENIOR_PRIVATE_BANKER_ROLE,
    UNDERWRITER_BANKER_ROLE,
    LOAN_OFFICER_ROLE,
    COMPLIANCE_ADMINISTRATOR_ROLE,
    PRIVATE_WEALTH_ADVISOR_ROLE,
    UnderReviewPrivateBankerId,
    UnderReviewUnderwriterBanker,
} from "../constants/DataConstants";

// Banker/Underwriter Adjustment feature (BankerAdjustmentExecutionPlan.md Section 2/8.1).
// Scoped narrowly to this feature's two checks -- deliberately not a refactor of the many other
// ad hoc `localStorage.getItem("userRole") === X` checks already scattered through this codebase
// (e.g. ConcludeLoanRequest.js, CommentSection.js), which follow the same idiom but for unrelated
// decisions. Reading straight from localStorage here matches that existing idiom rather than
// introducing a new state-management pattern for just this feature.

/**
 * True for every role allowed to see the Adjusted/Reason columns at all. Senior Private Banker
 * and Underwriter Banker can also edit (see canAdjust below); Loan Officer, Compliance
 * Administrator, and Wealth Advisor are view-only -- they see the adjusted value and can browse
 * history via the Eye icon, but canAdjust always returns false for them so no Edit icon renders.
 */
export function canViewAdjustments(userRole = localStorage.getItem("userRole")) {
    return (
        userRole === SENIOR_PRIVATE_BANKER_ROLE ||
        userRole === UNDERWRITER_BANKER_ROLE ||
        userRole === LOAN_OFFICER_ROLE ||
        userRole === COMPLIANCE_ADMINISTRATOR_ROLE ||
        userRole === PRIVATE_WEALTH_ADVISOR_ROLE
    );
}

/**
 * True only when the acting role matches the application's current review status:
 * Senior Private Banker while "Under Review Private Banker" (7), Underwriter Banker while
 * "Under Review Underwriter Banker" (8). Also false once the application's adjustments are
 * locked (post-Approval), regardless of role/status.
 */
export function canAdjust(applicationStatusId, isLocked = false, userRole = localStorage.getItem("userRole")) {
    if (isLocked) {
        return false;
    }
    const statusId = Number(applicationStatusId);
    if (userRole === SENIOR_PRIVATE_BANKER_ROLE) {
        return statusId === UnderReviewPrivateBankerId;
    }
    if (userRole === UNDERWRITER_BANKER_ROLE) {
        return statusId === UnderReviewUnderwriterBanker;
    }
    return false;
}
